var exports = {
  "p": "AutocompleteChannel.module__channelIcon___OE9mU2",
};

module.exports = exports;
